<template>
  <div>
    <com-table :columns="columns" :api="api" ref="tableRef" :defaultParams="defaultParams">
      <template #operation="row">
        <div class="flex">
          <el-button type="primary" size="mini" @click="handleUnbind(row.data)">解绑</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="handleReboot(row.data)"
            v-if="typeOfView === 'site'"
            >重启</el-button
          >
        </div>
      </template>
      <template #createTime="row">
        {{ row.data.createTime | formatDate }}
      </template>
      <template #operationTime="row"> {{ row.data.operationTime }}天 </template>
      <template #deviceStatus="row">
        {{ equStatus[row.data.deviceStatus] }}
      </template>
    </com-table>
    <the-bind-equ ref="bindEquRef" @success="init"></the-bind-equ>
  </div>
</template>

<script>
import { findDeviceApl, unBindEquApi, rebootSingleEquApi } from '@/api/site'
import { partnerEquListApi } from '@/api/equ'
import theBindEqu from '@/views/site/components/the-bind-equ'

export default {
  components: { theBindEqu },
  props: {
    defaultParams: {
      type: Object,
      default: () => {}
    },
    typeOfView: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      api: findDeviceApl,
      equStatus: {
        1: '在线',
        2: '离线'
      },
      columns: [
        {
          label: '设备号',
          prop: 'sn',
          minWidth: '180'
        },
        {
          label: '二维码',
          prop: 'label',
          width: '180'
        },
        {
          label: '关联主机',
          prop: 'masterLabel',
          width: '180'
        },
        {
          label: '已运营时间',
          prop: 'operationTime',
          minWidth: '80',
          type: 'slot',
          slotName: 'operationTime'
        },
        {
          label: '网络',
          prop: 'network',
          minWidth: '100'
        },
        {
          label: '设备状态',
          prop: 'deviceStatus',
          minWidth: '100',
          type: 'slot',
          slotName: 'deviceStatus'
        },
        {
          label: '可用端口',
          prop: 'availablePort',
          minWidth: '90'
        },
        {
          label: '绑定时间',
          prop: 'createTime',
          minWidth: '120',
          type: 'slot',
          slotName: 'createTime'
        },

        {
          label: '订单笔数',
          prop: 'orderCount',
          minWidth: '80'
        },
        {
          label: '订单金额',
          prop: 'orderAmount',
          minWidth: '100'
        },
        {
          label: '创建人',
          prop: 'createBy',
          minWidth: '100'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          fixed: 'right',
          minWidth: '150'
        }
      ]
    }
  },
  watch: {
    typeOfView: {
      handler(val) {
        if (val !== 'site') {
          this.columns.splice(-1, 1)
        }

        if (val !== 'site') {
          this.api = partnerEquListApi
        }
        if (val === 'site') {
          const addColumns = [
            {
              label: 'IMEI',
              prop: 'deviceCommModuleBean.imei',
              minWidth: '160'
            },
            {
              label: '版本号',
              prop: 'deviceCommModuleBean.deviceVersion',
              minWidth: '100'
            },
            {
              label: 'ICCID',
              prop: 'deviceCommModuleBean.iccid',
              minWidth: '200'
            },
            {
              label: '信号',
              prop: 'deviceCommModuleBean.signalVal',
              minWidth: '100'
            },
            {
              label: '电压',
              prop: 'deviceCommModuleBean.voltage',
              minWidth: '100'
            }
          ]

          this.columns = this.columns.concat(addColumns)
          console.log('object :>> ')
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    init() {
      this.$refs.tableRef.init()
    },
    search(val) {
      this.$refs.tableRef.search(val)
    },
    handleUnbind(val) {
      this.$confirm('此操作将解绑当前设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: val.code
          }
          unBindEquApi(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.init()
          })
        })
        .catch(() => {})
    },
    handleBind(val) {
      console.log('绑定新设备 :>> ', val)
      const params = {
        refStore: this.defaultParams.refStore,
        type: val.type
      }
      this.$refs.bindEquRef.open(params)
    },
    // 重启设备
    handleReboot(e) {
      console.log('e :>> ', e)
      this.$confirm('是否确认重启该设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const params = {
            sn: e.sn
          }
          const res = await rebootSingleEquApi(params)
          if (res) {
            this.$message.success(res.desc)
            this.$refs.table.getList()
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
